import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './Pages.css';
import foundationImage from '../media/foundation.jpg';
import engineImage from '../media/engine.jpg';
import newTiger from '../media/new-tiger.jpg';
import trimImage from '../media/trim.jpg';
import interiorImage from '../media/interior.jpg';
import upgradeImage from '../media/upgrade.jpg';
import twoPlane from '../media/2plane.jpg';
const History = () => {
  return (
    <div className="page">
      <h1>Our History</h1>
      <p>Discover the journey of York Travelers from its humble beginnings to today.</p>

      <div className="history-content">
        <VerticalTimeline>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="April 15, 1996"
            iconStyle={{ background: '#C0C0C0', color: 'rgba(101, 71, 71, 0.53)' }}
          >
            <div className="timeline-image-container">
              <img src={foundationImage} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Foundation</h3>
            <h4 className="vertical-timeline-element-subtitle">York, PA</h4>
            <p>YTFC was incorporated in York, PA. The Club began with a Grumman Traveler 5805L.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="1997"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={newTiger} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Rebranding</h3>
            <p>Traveler 5805L became N99YT with a new paint job and interior.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="November 2000"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={twoPlane} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Aircraft Sale</h3>
            <p>Sold Grumman Traveler N99YT (Serial #005) to purchase N28665 (Serial #739).</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="April 2001"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={interiorImage} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Avionics Retrofit</h3>
            <p>As the new owner, the aircraft received a full avionics retrofit.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="2008"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={engineImage} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Engine & Repairs</h3>
            <p>Installed a new engine and completed repairs to the tail brackets.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="2010"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={upgradeImage} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Avionics Upgrade</h3>
            <p>Added KT 73 Mode S Transponder, KMA 28 audio panel, EDM 830 display, and Alpha Systems AOA.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="2010"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <h3 className="vertical-timeline-element-title">Interior Upgrade</h3>
            <p>Installed new leather seats, side panels, and carpet.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: '#470909', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid #470909' }}
            date="2015"
            iconStyle={{ background: '#C0C0C0', color: '#470909' }}
          >
            <div className="timeline-image-container">
              <img src={trimImage} alt="Foundation" className="timeline-image" />
            </div>
            <h3 className="vertical-timeline-element-title">Interior Finishing Touches</h3>
            <p>Installed new ABS interior trim, headliner, and SoundEx sound deadener.</p>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
};

export default History;
